import { SHStack, SHTypography } from "@components/design-systems";
import { AnalysisDataDTO } from "@models/platform-analysis/entities/steps/feature";
import { memo } from "react";

type Props = {
  analysisData: AnalysisDataDTO;
};

export const GroupScoreProductCell = memo(({ analysisData }: Props) => {
  const score = analysisData?.totalScore ?? 0;
  const isValidScore = !isNaN(Number(score));

  if (!isValidScore) return null;

  return (
    <SHStack
      className={"GroupScoreProductCell"}
      width={"100%"}
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <SHTypography variant={"subtitle2"} lineHeight={"120%"} fontSize={13}>
        Group score
      </SHTypography>
      <SHTypography variant={"subtitle2"} lineHeight={"120%"} fontSize={13}>
        {` ${analysisData?.totalScore}%`}
      </SHTypography>
    </SHStack>
  );
});
